"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DateInput = _interopRequireDefault(require("./DateInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line no-unused-vars

const useIsMount = () => {
  const isMountRef = _react.default.useRef(true);
  _react.default.useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
const dateFormats = {
  date: 'MM/dd/yyyy',
  month: 'MM/yyyy',
  quater: 'QQQ, yyyy',
  year: 'yyyy'
};
const DateInputRange = /*#__PURE__*/_react.default.forwardRef(
// eslint-disable-next-line no-unused-vars
(_ref, ref) => {
  let {
    disableFuture,
    disablePast,
    minDate,
    maxDate,
    type,
    onDateChange,
    controlError,
    UI,
    dateFormat
  } = _ref;
  const [date1, setDate1] = _react.default.useState();
  const [date2, setDate2] = _react.default.useState();
  const [error, setError] = _react.default.useState(null);
  const isMount = useIsMount();
  const checkDateRange = () => {
    setError(null);
    const errorValue = {};
    if (!date1 || !date2) {
      if (!date1) {
        errorValue.error1 = 'Start date is required';
      }
      if (!date2) {
        errorValue.error2 = 'End date is required';
      }
      setError(errorValue);
    } else if (dateFormats.date === dateFormat || !dateFormat) {
      if (new Date(date1) > new Date(date2)) {
        errorValue.error3 = 'The End date cannot be before the Start date';
        setError(errorValue);
      }
    } else if (dateFormats.month === dateFormat) {
      if (new Date(`01/${date1}`) > new Date(`01/${date2}`)) {
        errorValue.error3 = 'The End date cannot be before the Start date';
        setError(errorValue);
      }
    } else if (dateFormats.quater === dateFormat) {
      // date1
      let qDate1 = date1;
      if (date1.includes('Q1')) {
        qDate1 = date1.replace('Q1, ', '03/01/');
      }
      if (date1.includes('Q2')) {
        qDate1 = date1.replace('Q2, ', '06/01/');
      }
      if (date1.includes('Q3')) {
        qDate1 = date1.replace('Q3, ', '09/01/');
      }
      if (date1.includes('Q4')) {
        qDate1 = date1.replace('Q4, ', '12/01/');
      }
      // date2
      let qDate2 = date2;
      if (date2.includes('Q1')) {
        qDate2 = date2.replace('Q1, ', '03/01/');
      }
      if (date2.includes('Q2')) {
        qDate2 = date2.replace('Q2, ', '06/01/');
      }
      if (date2.includes('Q3')) {
        qDate2 = date2.replace('Q1, ', '09/01/');
      }
      if (date2.includes('Q4')) {
        qDate2 = date2.replace('Q4, ', '12/01/');
      }
      if (new Date(qDate1) > new Date(qDate2)) {
        errorValue.error3 = 'The End date cannot be before the Start date';
        setError(errorValue);
      }
    } else if (dateFormats.year === dateFormat) {
      if (date1 > date2) {
        errorValue.error3 = 'The End date cannot be before the Start date';
        setError(errorValue);
      }
    }
  };
  _react.default.useEffect(() => {
    if (!isMount) {
      checkDateRange();
      onDateChange({
        date1,
        date2
      });
    }
  }, [date1, date2]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "columns is-mobile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "column is-align-items-end"
  }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
    UI: UI,
    controlError: controlError,
    label: "Starting" // to show the label against the input
    ,
    selectedDate: date1 // Starting date value for the input
    ,
    dateFormat: type ? dateFormats[type] : dateFormat // date format
    ,
    onDateChange: val => setDate1(val) // change event with return value
    ,
    minDate: minDate,
    maxDate: maxDate,
    onBlur: data => {
      checkDateRange(data);
    }
  }), error?.error1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-danger"
  }, error?.error1)), error?.error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-danger"
  }, error?.error))), /*#__PURE__*/_react.default.createElement("div", {
    className: "column is-align-items-end"
  }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
    UI: UI,
    controlError: controlError,
    label: "Ending" // to show the label against the input
    ,
    selectedDate: date2 // Ending date value for the input
    ,
    dateFormat: type ? dateFormats[type] : dateFormat // date format
    ,
    onDateChange: val => setDate2(val) // change event with return value
    ,
    disableFuture: disableFuture,
    disablePast: disablePast,
    minDate: minDate,
    maxDate: maxDate,
    onBlur: data => {
      checkDateRange(data);
    }
  }), error?.error2 && /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-danger"
  }, error?.error2), error?.error && /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-danger"
  }, error?.error), error?.error3 && /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-danger"
  }, error?.error3)));
});
DateInputRange.propTypes = {
  disablePast: _propTypes.default.bool,
  disableFuture: _propTypes.default.bool,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  type: _propTypes.default.oneOf(['date', 'month', 'quater', 'year']),
  onDateChange: _propTypes.default.func,
  controlError: _propTypes.default.string,
  UI: _propTypes.default.object,
  dateFormat: _propTypes.default.string
};
DateInputRange.displayName = 'DateInputRange'; // defining the display name for DateRange component
var _default = exports.default = DateInputRange;
//# sourceMappingURL=DateInputRange.js.map